import Spinner from '@atlaskit/spinner';

export const IframePlaceholder = () => {
	return <Spinner />;
};
